<template>
    <div class="outer-box">
        <!--        <div class="m-portlet  m-portlet&#45;&#45;head-sm left  m-b-0">-->
        <!--            <div class="m-portlet__head">-->
        <!--                <div class="m-portlet__head-caption">-->
        <!--                    <div class="m-portlet__head-title">-->
        <!--                        <h3 class="m-portlet__head-text">-->
        <!--                            筛选条件-->
        <!--                        </h3>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="m-portlet__body m-portlet__body&#45;&#45;small-padding ">-->
        <!--                <el-form label-position="top">-->
        <!--                    <el-form-item label="筛选学校">-->
        <!--                        <el-select v-model="filter.school_id" clearable placeholder="请选择学校" filterable remote-->
        <!--                                   :remote-method="handleSearchSchool" @change="handleIndexStudent()">-->
        <!--                            <el-option-->
        <!--                                    v-for="item in schools"-->
        <!--                                    :key="item.id"-->
        <!--                                    :label="item.name"-->
        <!--                                    :value="item.id">-->
        <!--                            </el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item label="筛选年级">-->
        <!--                        <el-select v-model="filter.grade_id" clearable placeholder="请选择年级" @change="handleIndexStudent()">-->
        <!--                            <el-option-->
        <!--                                    v-for="item in grades"-->
        <!--                                    :key="item.id"-->
        <!--                                    :label="item.name"-->
        <!--                                    :value="item.id">-->
        <!--                            </el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item label="筛选班主任">-->
        <!--                        <el-select v-model="filter.headTeacher_id" clearable placeholder="请选择班主任" filterable remote-->
        <!--                                   :remote-method="handleSearchHeadTeacher" @change="handleIndexStudent()">-->
        <!--                            <el-option-->
        <!--                                    v-for="item in headTeachers"-->
        <!--                                    :key="item.id"-->
        <!--                                    :label="item.name"-->
        <!--                                    :value="item.id">-->
        <!--                            </el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item label="筛选学期有课学生">-->
        <!--                        <el-select v-model="filter.semester_id" placeholder="请选择学期" @change="handleIndexStudent()">-->
        <!--                            <el-option-->
        <!--                                    v-for="item in semesters"-->
        <!--                                    :key="item.id"-->
        <!--                                    :label="item.name"-->
        <!--                                    :value="item.id">-->
        <!--                            </el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item label="筛选是否有班主任的学生">-->
        <!--                        <el-select v-model="filter.hasHeadTeacher" clearable placeholder="是否有班主任的学生"-->
        <!--                                   @change="handleIndexStudent()">-->
        <!--                            <el-option-->
        <!--                                    v-for="item in hasHeadTeacherStudents"-->
        <!--                                    :key="item.value"-->
        <!--                                    :label="item.label"-->
        <!--                                    :value="item.value">-->
        <!--                            </el-option>-->
        <!--                        </el-select>-->
        <!--                    </el-form-item>-->

        <!--                </el-form>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="m-portlet  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            发送通知
                        </h3>
                    </div>
                </div>
                <div class="m-portlet__head-caption" style="text-align: right">
                    <el-button @click="handleCreateMessage">新建通知</el-button>
                </div>
            </div>
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderMessages"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-20"
                          size="middle">
                    <el-table-column prop="id" label="id"></el-table-column>
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column prop="text" label="内容"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleShowSend(scope.row.id)">查看被发送人
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    // import store from '@/store'

    export default {
        name: "index",
        data() {
            return {
                path: '/message/list',
                loading: true,
                messages: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                headTeachers: [],

                hasHeadTeacherStudents: [
                    {
                        value: '1',
                        label: '有班主任的学生'
                    }, {
                        value: '0',
                        label: '没有班主任的学生'
                    }],


                filter: {
                    grade_id: '',
                    school_id: '',
                    headTeacher_id: '',
                    confirmStudent: '',
                    hasHeadTeacher: '',
                },
                semesters: [],
                schools: [],
                grades: [],
            }
        },
        props: {},
        components: {},
        created() {
            this.handleInit();
            this.handleIndexMessage();
            this.handleCreate();
        },
        beforeDestroy() {
            this.$wApi.removeListen(this.path)
        },
        computed: {
            orderMessages: function () {
                return this._.values(this.messages);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.semesters = data.semesters;
                        this.grades = data.grades;
                        this.schools = data.schools;
                        this.headTeachers =  data.headTeachers;
                        break;
                    case 'list':
                        if (Object.keys(data.messages).length > 0) {
                            this.messages = data.messages;
                        } else {
                            this.messages = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'get_students':
                        this.students = data.students;
                        break;
                    case 'searchSchool':
                        this.schools = data.searchData;
                        break;
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                }
            },
            handleInit() {
                this.$wApi.send(this.path, 'init')
            },
            handleIndexMessage(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter': this.filter,
                });
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'searchSchool',
                    'schoolKeyName': query,
                })
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'headTeacherKeyName',
                    'headTeacherKeyName': query,
                })
            },

            handleStudentInformation(student_id, title) {
                this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/student/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + student_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexMessage(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexMessage(this.currentPage)
            },
            handleShowSend() {

            },
            handleCreateMessage() {
                this.$Win.openModal('Dialog_CreateMessage', 1000, 400, '创建新通知');
            }
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
